import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useContext } from 'react';
import { AppContext } from '../AppContext';

export const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const { token } = useParams();
  const navigate = useNavigate();
  const { port, addAlert } = useContext(AppContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    axios.post(`${port}/auth/reset-password`, {
      token,
      newPassword
    })
    .then(() => {
      setSuccess('Password reset successful!');
      addAlert('Password reset successful!', 'success');
      navigate('/login');
    })
    .catch((err) => {
      setError(err.response?.data?.message || 'Error resetting password');
    });
  };

  return (
    <div className="auth-container">
      <h2 className="auth-title">Reset Password</h2>
      <form className="auth-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <input
            type="password"
            placeholder="New Password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
          />
        </div>
        {error && <div className="auth-error">{error}</div>}
        {success && <div className="auth-message">{success}</div>}
        <button type="submit" className="auth-button">
          Reset Password
        </button>
      </form>
    </div>
  );
}; 